import { useCallback, useEffect, useState } from 'react';
import { useBreakpointValue } from '@gemini/core';
import { usePageLayoutContext } from '../usePageLayoutContext/usePageLayoutContext';
/**
 * Hook that return true if the the screen width is less than table lower value or false otherwise
 *
 * @returns Object with boolean to indicate if mobile view
 */
export const useMobileViewDetect = () => {
    const { sidebarOpen } = usePageLayoutContext();
    const currentBreakpoint = useBreakpointValue({ base: 'md', lg: 'lg' });
    const isSmallScreen = useCallback(() => currentBreakpoint === 'md', [currentBreakpoint]);
    const [isMobileView, setIsMobileView] = useState(isSmallScreen());
    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(isSmallScreen());
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, [isSmallScreen, sidebarOpen]);
    return { isMobileView };
};
